import { toCx } from '../../../classname.js';
import { borderStyleMap, outlineStyleMap } from '../../../mappers.mappings.js';

var mapBorderValue = function mapBorderValue(border, type) {
  var _border$sides;
  if (typeof border.value === 'string') {
    return {
      classNames: [toCx(type, border.value)]
    };
  }
  return {
    classNames: (_border$sides = border.sides) === null || _border$sides === void 0 ? void 0 : _border$sides.map(function (side, index) {
      return toCx(type, "".concat(side, "-").concat(border.value[index]));
    })
  };
};
var borderStyleMapper = {
  border: function border(_border, _) {
    return mapBorderValue(_border, 'border');
  },
  borderRadius: function borderRadius(_borderRadius, _) {
    return mapBorderValue(_borderRadius, 'rounded');
  },
  borderStyle: function borderStyle(value, _) {
    return {
      classNames: [borderStyleMap[value]]
    };
  },
  outlineStyle: function outlineStyle(value, _) {
    return {
      classNames: [outlineStyleMap[value]]
    };
  }
};

export { borderStyleMapper };
//# sourceMappingURL=border.js.map
